import type { FieldValues, Path, UseFormRegister } from 'react-hook-form';
import React from 'react';

export interface HiddenInputProps<T extends FieldValues> {
  label: string;
  name: Path<T>;
  register: UseFormRegister<T>;
  error?: string;
  required?: boolean;
  value: string;
  children?: React.ReactNode;
}

export const HiddenInput = <T extends FieldValues>({
  label,
  name,
  error = '',
  register,
  value,
  required = false,
  children = undefined
}: HiddenInputProps<T>) => {
  return (
    <div>
      <div className="flex items-center">
        <label
          htmlFor="startAt"
          className="text-soClean-100 rounded-md text-xs leading-6"
        >
          {label}
        </label>
        <p className="text-roses self-start px-1 text-xs">*</p>
      </div>

      <input
        type="hidden"
        required
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...register(name, { required })}
        defaultValue={value}
        readOnly
      />
      {children}
      {error && (
        <p
          className="text-roses text-xs"
          data-testid="startAt-validation-error"
        >
          {error}
        </p>
      )}
    </div>
  );
};
